"use client";

// src/use-aria-textfield.ts
import { filterDOMProps, mergeProps } from "@react-aria/utils";
import { useAriaField } from "@nextui-org/use-aria-field";
import { useFocusable } from "@react-aria/focus";
function useAriaTextField(props, ref) {
  let {
    inputElementType = "input",
    isDisabled = false,
    isRequired = false,
    isReadOnly = false,
    validationState,
    type = "text",
    onChange = () => {
    }
  } = props;
  let { focusableProps } = useFocusable(props, ref);
  let { labelProps, fieldProps, descriptionProps, errorMessageProps } = useAriaField(props);
  let domProps = filterDOMProps(props, { labelable: true });
  const inputOnlyProps = {
    type,
    pattern: props.pattern
  };
  return {
    labelProps,
    inputProps: mergeProps(domProps, inputElementType === "input" && inputOnlyProps, {
      disabled: isDisabled,
      readOnly: isReadOnly,
      required: isRequired,
      "aria-required": isRequired || void 0,
      "aria-invalid": validationState === "invalid" || void 0,
      "aria-errormessage": props["aria-errormessage"],
      "aria-activedescendant": props["aria-activedescendant"],
      "aria-autocomplete": props["aria-autocomplete"],
      "aria-haspopup": props["aria-haspopup"],
      "aria-readonly": isReadOnly,
      value: props.value,
      defaultValue: props.value ? void 0 : props.defaultValue,
      onChange: (e) => onChange(e.target.value),
      autoComplete: props.autoComplete,
      maxLength: props.maxLength,
      minLength: props.minLength,
      name: props.name,
      placeholder: props.placeholder,
      inputMode: props.inputMode,
      onCopy: props.onCopy,
      onCut: props.onCut,
      onPaste: props.onPaste,
      onCompositionEnd: props.onCompositionEnd,
      onCompositionStart: props.onCompositionStart,
      onCompositionUpdate: props.onCompositionUpdate,
      onSelect: props.onSelect,
      onBeforeInput: props.onBeforeInput,
      onInput: props.onInput,
      ...focusableProps,
      ...fieldProps
    }),
    descriptionProps,
    errorMessageProps
  };
}

export {
  useAriaTextField
};
